export default __webpack_public_path__ + "static/media/sponsers-x2.9ed9df2a.png";